module.exports = __webpack_public_path__ + "static/media/Path7.d50f318d.png";